<template>
    <div id="login_comp">
        <section class="content">
            <app-menu v-if="isLoggedIn"></app-menu>
            <div class="container-fluid">
                <div class="row clearfix">

                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="card">


                            <div class="login-register-top">

                                <div class="login-register-top-block">
                                    <p> <br/>
                                        <strong>Add Employee</strong>
                                    </p>

                                </div>

                                <!--<div class="or">OR</div>-->

                                <!--<div class="login-register-top-block pull-right">-->
                                <!--<p>CALL US ON <br/>-->
                                <!--<strong>855 583 5624</strong>-->
                                <!--</p>-->

                                <!--</div>-->

                            </div>
                            <div class="body">
                                <form class="form-inline" id="registerForm">
                                    <label for="email">First Name :</label>
                                    <input class="form-control" id="first_name" name="first_name" type="text">
                                    <div style="color: red ; text-align: center">
                                        {{companyerror}}
                                    </div>
                                    <label for="email">Middle Name :</label>
                                    <input class="form-control" id="middle_name" name="middle_name" type="text">
                                    <label for="email">Last Name :</label>
                                    <input class="form-control" id="last_name" name="last_name" type="text">
                                    <div style="color: red ; text-align: center">
                                        {{doterror}}
                                    </div>
                                    <label for="email">Email :</label>
                                    <input type="email" class="form-control" id="email" name="email">
                                    <div style="color: red; text-align: center">
                                        {{emailerror}}
                                    </div>
                                    <label for="email">Phone :</label>
                                    <input class="form-control input-half-width" id="phone" name="phone" type="text">
                                    <span>(example: 4445674444)</span>
                                    <label for="email">Business Unit ID :</label>
                                    <div class="row clearfix">
                                        <div class="body">
                                            <div class="row clearfix col-md-6">
                                                <v-select v-model="businessId" placeholder="Select Business ID" id="businessId" label="text" class="custom-vselect"  :options="businessIdArr"></v-select>
                                            </div>
                                        </div>
                                    </div>

                                    <label for="email">Status :</label>
                                    <div class="row clearfix">
                                        <div class="body">
                                            <div class="row clearfix col-md-6">
                                                <v-select v-model="Status" placeholder="Status" id="Status" label="text" class="custom-vselect"  :options="StatusArr"></v-select>
                                            </div>
                                        </div>
                                    </div>
                                    <label for="email">Username:</label>
                                    <input class="form-control" id="username" name="username" type="text">
                                    <div style="color: red; text-align: center">
                                        {{usererror}}
                                    </div>
                                    <label for="email">Password :</label>
                                    <input class="form-control" id="password" name="password" type="password">
                                    <div style="color: red; text-align: center">
                                        {{passworderror}}
                                    </div>
                                    <label for="email">Confirm Password :</label>
                                    <input class="form-control" id="compare_password" name="compare_password" type="password">
                                    <div style="color: red; text-align: center">
                                        {{passworderror}}
                                    </div>
                                    <div class="row clearfix">
                                        <label for="email">Time Zone :</label>
                                        <div class="body">
                                            <div class="row clearfix col-md-6">
                                                <v-select v-model="selectedTimezone" placeholder="Select Timzone" id="timezone" label="text" class="custom-vselect"  :options="timezones"></v-select>
                                            </div>
                                        </div>
                                    </div>
                                    <!--<div class="form-group">-->

                                    <!--<input class="form-control" id="role" name="role" type="hidden" value="customer">-->
                                    <!--</div>-->
                                    <p v-if="formerrors.length">
                                    <ul>
                                        <li v-for = "formerror in formerrors" :key="formerror.id" v-bind:class="msgClass" style="text-align: center">{{ formerror }}</li>
                                    </ul>
                                    <div class="form-group">
                                        <label></label>
                                        <div class="login-register-button">
                                            <a href="javascript:void(0)" v-on:click="register(this)" >{{Registerbtn}}</a>
                                        </div>
                                    </div>

                                </form>
                            </div>
                            <!--<div class="login_here">-->

                            <!--<div class="information-details">-->
                            <!--<div class="login-register-top">-->

                            <!--<div class="login-register-top-block">-->
                            <!--<p>already a member <br/>-->
                            <!--<strong>login here</strong>-->
                            <!--</p>-->

                            <!--</div>-->

                            <!--</div>-->
                            <!--</div>-->

                            <!--</div>-->
                        </div>
                    </div>

                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import EventBus from '../event-bus';
    import {employeeUrl, configs, businessUnitUrl} from '../../config';
    import FrontMenu from '@/components/partials/FrontMenu';
    // import EventBus from '../event-bus.js';
    import SessioMixin from '../../mixins/sessionmixin';
    export default {
        name: "login_comp",
        mixins: [SessioMixin],
        data: () => ({
                isLoggedIn: false,
                company: "",
                username: "",
                password: "",
                compare_password: "",
                dot: "",
                email: "",
                formerrors: [],
                usererror: "",
                emailerror: "",
                passworderror: "",
                companyerror: "",
                doterror: "",
                flag: "",
                error: "",
                logerror_msg: "",
                passerror_msg: "",
                msgClass: "",
                Status: "",
                StatusArr: [
                    {value: 'active', text: 'Active'},
                    {value: 'inactive', text: 'Inactive'}
                ],
                businessId: "",
                businessIdArr: {value: "", text: ""},
                registerError: "",
                loginUsername: "",
                loginPassword: "",
                role: "customer",
                Registerbtn: "Register",
                Loginbtn: "Login",
                userAgent: "",
                first_name: "",
                middle_name: "",
                last_name: "",
                timezones: [],
                selectedTimezone: {value: "", text: 'Select Timezone'}
            }),
        mounted: function () {
            $(".removeActive").removeClass('active');
            $("#menuemployee").addClass('active');
            var self = this;
            if (localStorage.getItem("menu_small") == '1') {
                self.menuSmall();
            } else {
                self.menuBig();
            }

            self.fetchBusinessUnit();
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }

        },
        beforeMount: function () {
            var app = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                this.isLoggedIn = true;
            }
        },
        methods: {
            register: function () {
                var self = this;

                this.first_name = $("#first_name").val();
                this.username = $("#username").val();
                this.middle_name = $('#middle_name').val();
                this.last_name = $("#last_name").val();
                this.email = $("#email").val();
                this.password = $("#password").val();
                this.compare_password = $("#compare_password").val();
                // this. = $("#contact").val();
                this.phone = $("#phone").val();

                var formerrors_msg = "";
                this.formerrors = [];
                this.usererror = "";
                this.emailerror = "";
                this.passworderror = "";
                this.companyerror = "";
                this.doterror = "";

                if (
                        this.validEmail(this.username) &&
                        this.password &&
                        this.last_name &&
                        this.validEmail(this.email) &&
                        this.first_name &&
                        this.password == this.compare_password
                        )
                    if (!this.validEmail(this.username)) {

                        this.usererror = " * Username required.";
                    } else {
                        this.usererror = "";
                    }

                if (!this.validEmail(this.username)) {
                    this.usererror = "* Username required.";
                }
                if (!this.password) {
                    this.passworderror = "* Password required.";
                }
                if (!this.first_name) {
                    this.companyerror = "* Company name required.";
                }

                if (!this.last_name) {
                    this.doterror = "* DOT number required.";
                }

                if (this.password != this.compare_password) {
                    this.passworderror = "* Password does not match";
                }
                if (!this.validEmail(this.email)) {
                    this.emailerror = "* Enter valid email.";
                }

                if (!this.formerrors.length && this.passworderror == "" && this.emailerror == "" && this.companyerror == ""
                        && this.doterror == "" && this.usererror == "") {


                    var fields = $("#registerForm").serializeArray();
                    fields.push({name: 'timezone', value: self.selectedTimezone.value});
                    fields.push({name: 'business_unit', value: self.businessId.value});

                    fields.push({name: 'status', value: self.Status.value});
                    self.Registerbtn = "Processing...";
                    // self.Registerbtn = "Processing...";
                    $.ajax({
                        url: process.env.ROOT_API + "/add_employee",
                        type: "POST",
                        crossDomain: true,
                        headers: {
                            'Accept': 'application/json',
                            "Access-Control-Allow-Origin": '*',
                            "Authorization": "Bearer " + localStorage.getItem("api_token"),
                            'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                            "Cache-Control": "no-cache"
                        },
                        data: fields,
                        success: function (data) {

                            self.Registerbtn = "Register";

                            if (data.status == "success") {

                                self.formerrors.push(data.message);
                                self.msgClass = "success";

                                document.getElementById("registerForm");
                                $("#registerForm").trigger("reset");

                            } else if (data.status == "error") {

                                self.formerrors.push(data.message);
                                self.msgClass = "error";
                            }

                            //self.$router.push("/");
                        },
                        error: function (jqXHR, exception) {
                            self.Registerbtn = "Register";
                            if (jqXHR.status == 0) {
                                self.registerError = "Remote server can not be reachable";
                            } else {
                                var formerrors = "";
                                if (
                                        typeof jqXHR.responseJSON.content.email !== "undefined" &&
                                        jqXHR.responseJSON.content.email.length > 0
                                        ) {
                                    self.formerrors.push(jqXHR.responseJSON.content.email[0]);
                                    $(".error_style").addClass("error");
                                }
                                if (
                                        typeof jqXHR.responseJSON.content.username !== "undefined" &&
                                        jqXHR.responseJSON.content.username.length > 0
                                        ) {
                                    self.formerrors.push(jqXHR.responseJSON.content.username[0]);
                                    $(".error_style").addClass("error");
                                }
                                if (
                                        typeof jqXHR.responseJSON.content.password !== "undefined" &&
                                        jqXHR.responseJSON.content.password.length > 0
                                        ) {
                                    $(".error_style").addClass("error");
                                    self.formerrors.push(jqXHR.responseJSON.content.password[0]);
                                }
                                self.msgClass = "error";
                            }
                            // self.registerError = formerror;
                        }
                    });
                } else {
                    //console.log($(".error_style").length);
                    self.msgClass = "error";
                }
            },
            validEmail: function (email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },

            fetchBusinessUnit: function () {
                var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/fetch_business_unit",
                    type: "GET",
                    crossDomain: true,
                    success: function (data) {

                        self.Registerbtn = "Register";

                        if (data.status == "success") {

                            self.businessIdArr = data.content;
                        }
                        //self.$router.push("/");
                    },
                    error: function (jqXHR, exception) {
                        self.Registerbtn = "Register";
                        if (jqXHR.status == 0) {
                            self.registerError = "Remote server can not be reachable";
                        } else {

                        }
                        // self.registerError = formerror;
                    }
                });
            },
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
                $("html, body").animate({scrollTop: 0}, 10);
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
                $("html, body").animate({scrollTop: 0}, 10);
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/employee/AddEmployee.vue